import { render, staticRenderFns } from "./PricingOptionButton.vue?vue&type=template&id=e88acf52&scoped=true&"
import script from "./PricingOptionButton.vue?vue&type=script&lang=js&"
export * from "./PricingOptionButton.vue?vue&type=script&lang=js&"
import style0 from "./PricingOptionButton.vue?vue&type=style&index=0&id=e88acf52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88acf52",
  null
  
)

export default component.exports